/*
 * tooltip Tippy
 * all props can be found https://atomiks.github.io/tippyjs/v6/all-props/
 */

const tippySelector = '.tooltip-icon-wrapper';
let Tippy;

function initializeTippy() {
    Tippy(tippySelector, {
        duration: 150,
        arrow: true,
        allowHTML: true,
        theme: 'awb',
        maxWidth: 150,
        animation: 'scale',
        placement: 'top',
    });
}

ready().then(function() {
    const tippyElements = document.querySelectorAll(tippySelector);

    if ( tippyElements.length > 0 ) {
        import('tippy.js').then((imported) => {
            Tippy = imported.default

            initializeTippy();
        });
    }
});
